module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/17b20e238552e00772bee085bda0b094.png";